/** Identificador temporário utilizado para identificar qual o modo da central de compras que a empresa está utilizando até conseguirmos fazer a migração dos referenciados para os cadastros */
export interface ModoCentralCompra {
    id: number;
    nome: string;
}

export const modoCentralCompraCadastro: ModoCentralCompra = {id: 1, nome: 'Cadastro'};
export const modoCentralCompraReferencia: ModoCentralCompra = {id: 2, nome: 'Referência'};

/** Verifica se o modo da central de compras é cadastro */
export function isModoCentralCompraCadastro(id: number): boolean {
    return id === modoCentralCompraCadastro.id;
}

/** Verifica se o modo da central de compras é referência */
export function isModoCentralCompraReferencia(id: number): boolean {
    return id === modoCentralCompraReferencia.id;
}
